module.exports = __webpack_public_path__ + "static/media/star-half.ceff0c08.svg";